import React from "react";

export const LoadingButton = () => {
  return (
    <div
      className=" h-100 w-100 d-flex justify-content-center align-items-center"
      //   style={{ height: "12px", width: "12px" }}
    >
      <div className="spinner-border spinner-border-sm " role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

const Loading = () => {
  return (
    <div className=" h-100 d-flex justify-content-center py-3 my-5">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Loading;
